function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module editor-classic/classiceditorui
 */
import EditorUI from '@ckeditor/ckeditor5-core/src/editor/editorui';
import enableToolbarKeyboardFocus from '@ckeditor/ckeditor5-ui/src/toolbar/enabletoolbarkeyboardfocus';
import normalizeToolbarConfig from '@ckeditor/ckeditor5-ui/src/toolbar/normalizetoolbarconfig';
import { enablePlaceholder } from '@ckeditor/ckeditor5-engine/src/view/placeholder';
import ElementReplacer from '@ckeditor/ckeditor5-utils/src/elementreplacer';
/**
 * The classic editor UI class.
 *
 * @extends module:core/editor/editorui~EditorUI
 */

var ClassicEditorUI =
/*#__PURE__*/
function (_EditorUI) {
  _inherits(ClassicEditorUI, _EditorUI);

  /**
   * Creates an instance of the classic editor UI class.
   *
   * @param {module:core/editor/editor~Editor} editor The editor instance.
   * @param {module:ui/editorui/editoruiview~EditorUIView} view The view of the UI.
   */
  function ClassicEditorUI(editor, view) {
    var _this;

    _classCallCheck(this, ClassicEditorUI);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ClassicEditorUI).call(this, editor));
    /**
     * The main (top–most) view of the editor UI.
     *
     * @readonly
     * @member {module:ui/editorui/editoruiview~EditorUIView} #view
     */

    _this.view = view;
    /**
     * A normalized `config.toolbar` object.
     *
     * @private
     * @member {Object}
     */

    _this._toolbarConfig = normalizeToolbarConfig(editor.config.get('toolbar'));
    /**
     * The element replacer instance used to hide the editor's source element.
     *
     * @protected
     * @member {module:utils/elementreplacer~ElementReplacer}
     */

    _this._elementReplacer = new ElementReplacer();
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ClassicEditorUI, [{
    key: "init",

    /**
     * Initializes the UI.
     *
     * @param {HTMLElement|null} replacementElement The DOM element that will be the source for the created editor.
     */
    value: function init(replacementElement) {
      var editor = this.editor;
      var view = this.view;
      var editingView = editor.editing.view;
      var editable = view.editable;
      var editingRoot = editingView.document.getRoot(); // The editable UI and editing root should share the same name. Then name is used
      // to recognize the particular editable, for instance in ARIA attributes.

      editable.name = editingRoot.rootName;
      view.render(); // The editable UI element in DOM is available for sure only after the editor UI view has been rendered.
      // But it can be available earlier if a DOM element has been passed to BalloonEditor.create().

      var editableElement = editable.element; // Register the editable UI view in the editor. A single editor instance can aggregate multiple
      // editable areas (roots) but the classic editor has only one.

      this.setEditableElement(editable.name, editableElement); // Let the global focus tracker know that the editable UI element is focusable and
      // belongs to the editor. From now on, the focus tracker will sustain the editor focus
      // as long as the editable is focused (e.g. the user is typing).

      this.focusTracker.add(editableElement); // Let the editable UI element respond to the changes in the global editor focus
      // tracker. It has been added to the same tracker a few lines above but, in reality, there are
      // many focusable areas in the editor, like balloons, toolbars or dropdowns and as long
      // as they have focus, the editable should act like it is focused too (although technically
      // it isn't), e.g. by setting the proper CSS class, visually announcing focus to the user.
      // Doing otherwise will result in editable focus styles disappearing, once e.g. the
      // toolbar gets focused.

      view.editable.bind('isFocused').to(this.focusTracker); // Bind the editable UI element to the editing view, making it an end– and entry–point
      // of the editor's engine. This is where the engine meets the UI.

      editingView.attachDomRoot(editableElement); // If an element containing the initial data of the editor was provided, replace it with
      // an editor instance's UI in DOM until the editor is destroyed. For instance, a <textarea>
      // can be such element.

      if (replacementElement) {
        this._elementReplacer.replace(replacementElement, this.element);
      }

      this._initPlaceholder();

      this._initToolbar();

      this.fire('ready');
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var view = this.view;
      var editingView = this.editor.editing.view;

      this._elementReplacer.restore();

      editingView.detachDomRoot(view.editable.name);
      view.destroy();

      _get(_getPrototypeOf(ClassicEditorUI.prototype), "destroy", this).call(this);
    }
    /**
     * Initializes the editor toolbar.
     *
     * @private
     */

  }, {
    key: "_initToolbar",
    value: function _initToolbar() {
      var editor = this.editor;
      var view = this.view;
      var editingView = editor.editing.view; // Set–up the sticky panel with toolbar.

      view.stickyPanel.bind('isActive').to(this.focusTracker, 'isFocused');
      view.stickyPanel.limiterElement = view.element;

      if (this._toolbarConfig.viewportTopOffset) {
        view.stickyPanel.viewportTopOffset = this._toolbarConfig.viewportTopOffset;
      }

      view.toolbar.fillFromConfig(this._toolbarConfig.items, this.componentFactory);
      enableToolbarKeyboardFocus({
        origin: editingView,
        originFocusTracker: this.focusTracker,
        originKeystrokeHandler: editor.keystrokes,
        toolbar: view.toolbar
      });
    }
    /**
     * Enable the placeholder text on the editing root, if any was configured.
     *
     * @private
     */

  }, {
    key: "_initPlaceholder",
    value: function _initPlaceholder() {
      var editor = this.editor;
      var editingView = editor.editing.view;
      var editingRoot = editingView.document.getRoot();
      var sourceElement = editor.sourceElement;
      var placeholderText = editor.config.get('placeholder') || sourceElement && sourceElement.tagName.toLowerCase() === 'textarea' && sourceElement.getAttribute('placeholder');

      if (placeholderText) {
        enablePlaceholder({
          view: editingView,
          element: editingRoot,
          text: placeholderText,
          isDirectHost: false
        });
      }
    }
  }, {
    key: "element",
    get: function get() {
      return this.view.element;
    }
  }]);

  return ClassicEditorUI;
}(EditorUI);

export { ClassicEditorUI as default };